module.exports = __webpack_public_path__ + "img/landscape_8-lazy.4f019118.jpg";